import { Link } from 'react-router-dom';

/* Shared dark hero banner used on inner pages */
export function PageHero({ eyebrow, title, subtitle, ctas }: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  ctas?: Array<{ label: string; to: string; primary?: boolean; state?: { tab?: string; lockTab?: boolean; role?: string } }>;
}) {
  return (
    <section className="bg-hero relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/4 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl" />
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <h1 className="text-3xl sm:text-4xl font-medium text-white mb-4 max-w-2xl leading-tight">{title}</h1>
        {subtitle && <p className="text-[15px] text-white/60 max-w-xl leading-relaxed mb-8">{subtitle}</p>}
        {ctas && (
          <div className="flex flex-wrap gap-3">
            {ctas.map(c => (
              <Link
                key={c.label}
                to={c.to}
                state={c.state}
                className={c.primary
                  ? 'px-6 py-3 bg-blue text-white  text-[14px] font-bold rounded-md  transition-colors hover:bg-white hover:text-gray-900 shadow-lg'
                  : 'px-6 py-3 border bg-white border-white/25 text-gray-900 text-[14px] font-semibold rounded-md hover:bg-white/10 hover:text-white transition-colors'
                }
              >
                {c.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

/* Shared navy CTA footer banner */
export function CTABanner({ title, subtitle, primaryLabel, primaryTo, secondaryLabel, secondaryTo }: {
  title: string; subtitle: string;
  primaryLabel: string; primaryTo: string;
  secondaryLabel?: string; secondaryTo?: string;
}) {
  return (
    <section className="bg-hero">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <h2 className="text-[24px] font-medium text-white mb-3">{title}</h2>
        <p className="text-[14px] text-white/55 mb-8 max-w-md mx-auto">{subtitle}</p>
        <div className="flex gap-3 justify-center">
          <Link to={primaryTo} className="px-6 py-3 bg-white text-navy text-[13px] font-medium rounded-lg hover:bg-blue-50 transition-colors">{primaryLabel}</Link>
          {secondaryLabel && secondaryTo && (
            <Link to={secondaryTo} className="px-6 py-3 border border-white/25 text-white text-[13px] rounded-lg hover:bg-white/10 transition-colors">{secondaryLabel}</Link>
          )}
        </div>
      </div>
    </section>
  );
}
